import { render } from "./MainFooter.vue?vue&type=template&id=0aa38988&scoped=true"
import script from "./MainFooter.vue?vue&type=script&lang=js"
export * from "./MainFooter.vue?vue&type=script&lang=js"

import "./MainFooter.vue?vue&type=style&index=0&id=0aa38988&lang=scss&scoped=true"
import "./MainFooter.vue?vue&type=style&index=1&id=0aa38988&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aa38988"]])

export default __exports__